<template>
  <div class="qa-timeline" :class="{ 'qa-timeline--compact': compact }">
    <div v-for="entry in visibleEntries"
         :key="entry.id"
         class="qa-timeline__item"
         :class="'qa-timeline__item--' + entry.type"
         qid="qa-log-entry"
    >
      <span class="qa-timeline__marker">
        <font-awesome-icon :icon="icons[entry.type] || 'info-circle'"/>
      </span>
      <div class="qa-timeline__content">
        <div class="qa-timeline__header">
          <span class="qa-timeline__pill" :class="'qa-timeline__pill--' + entry.type">
            {{ $t('system.' + entry.type) }}
          </span>
          <span v-if="isOverwritten(entry)" class="qa-timeline__pill qa-timeline__pill--overwritten"
                v-b-tooltip.hover :title="$t('system.sign_off_overwritten_description')">
            {{ $t('system.sign_off_overwritten') }}
          </span>
          <span class="qa-timeline__user">
            <Avatar v-if="entry.user" :object="entry.user" size="xs"></Avatar>
            <span class="ml-1">{{ entry.user ? entry.user.name : '' }}</span>
          </span>
          <span class="qa-timeline__date">{{ entry.created_at | formatDateTime }}</span>
        </div>
        <div v-if="hasComment(entry)" class="qa-timeline__comment text-formatted">{{ entry.comment }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar.vue';

  // QA log entries (accepted, rejected, completed), newest first
  export default {
    name: 'QaLogTimeline',
    components: {
      Avatar
    },
    props: {
      // Oldest first, as the API returns them
      entries: {
        type: Array,
        default: () => []
      },
      limit: {
        type: Number,
        default: 0
      },
      compact: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        icons: {
          accepted: 'check-circle',
          rejected: 'times-circle',
          completed: 'check'
        }
      };
    },
    computed: {
      visibleEntries() {
        let entries = this.entries.slice().reverse();
        return this.limit ? entries.slice(0, this.limit) : entries;
      },
      lastRejectionId() {
        let rejections = this.entries.filter((entry) => entry.type === 'rejected');
        return rejections.length ? rejections[rejections.length - 1].id : 0;
      }
    },
    methods: {
      // An acceptance followed by a rejection stays in the log but no longer counts
      isOverwritten(entry) {
        return entry.type === 'accepted' && entry.id < this.lastRejectionId;
      },
      hasComment(entry) {
        return entry.comment && entry.comment !== 'accepted' && entry.comment.length > 0;
      }
    }
  };
</script>
